// Rubys.Group — refined geometric monogram + wordmark
export function LogoMark({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Rubys.Group"
    >
      <circle cx="24" cy="24" r="23" stroke="currentColor" strokeWidth="0.6" opacity="0.5" />
      {/* Engraved R serif monogram */}
      <path
        d="M18 14 H27.4 C30.6 14 33 16.1 33 19.6 C33 22.4 31.3 24.4 28.7 24.95 L33.6 34 H30.6 L26.05 25.4 H20.7 V34 H18 V14 Z M20.7 16.5 V22.9 H27.1 C29 22.9 30.1 21.7 30.1 19.7 C30.1 17.7 29 16.5 27.1 16.5 H20.7 Z"
        fill="currentColor"
      />
      {/* Ruby dot accent (period in brand) */}
      <circle cx="35" cy="34" r="1.3" fill="#8B1C31" />
    </svg>
  );
}

export default function Logo({ size = 32, withWordmark = true, tone = "ink", className = "" }) {
  // tone: "ink" (dark on cream) | "cream" (light on dark)
  const wordColor = tone === "cream" ? "text-cream-100" : "text-ink-700";
  const markColor = tone === "cream" ? "text-cream-100" : "text-ink-700";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark size={size} className={markColor} />
      {withWordmark && (
        <span className={`font-serif text-[1.4rem] leading-none tracking-[-0.01em] ${wordColor}`}>
          Rubys<span className="text-ruby">.</span>Group
        </span>
      )}
    </span>
  );
}
